import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import Close from "@material-ui/icons/Close";
import Edit from "@material-ui/icons/Edit";
import Video from "components/Video";

const VideoWrapper = styled.div`
  && {
    display: flex;
  }
`;

const ReelClipButton = styled(IconButton)`
  && {
    position: relative;
    top: -10px;
    z-index: 9;
    background-color: rgba(220, 220, 220, 0.8);
    width: 30px;
    height: 30px;
    color: rgba(0, 0, 0, 0.75);

    &:hover {
      background-color: rgba(220, 220, 220, 0.9);
    }
  }
`;

const OpenTrimPlayDialogButton = styled(ReelClipButton)`
  left: 50px;
`;

const RemoveButton = styled(ReelClipButton)`
  left: 313px;
`;

const EditIcon = styled(Edit)`
  position: relative;
  bottom: 8px;
`;

const CloseIcon = styled(Close)`
  position: relative;
  bottom: 8px;
`;

class ReelClip extends React.PureComponent {
  render() {
    const {
      index,
      clip,
      openTrimPlayDialog,
      removeHandler,
      handleVideoMetadata
    } = this.props;
    const { url, thumbnailUri } = clip;
    return (
      <VideoWrapper>
        <OpenTrimPlayDialogButton
          onClick={() => openTrimPlayDialog(index, url)}
        >
          <EditIcon style={{ top: "0", fontSize: "1.2rem" }} />
        </OpenTrimPlayDialogButton>
        <RemoveButton onClick={() => removeHandler(clip.id)}>
          <CloseIcon style={{ top: "0", fontSize: "1.2rem" }} />
        </RemoveButton>
        <Video
          handleVideoMetadata={handleVideoMetadata}
          src={url}
          thumbnailUri={thumbnailUri}
        />
      </VideoWrapper>
    );
  }
}

ReelClip.propTypes = {
  clip: PropTypes.object.isRequired,
  removeHandler: PropTypes.func.isRequired,
  handleVideoMetadata: PropTypes.func.isRequired
};

export default ReelClip;



// WEBPACK FOOTER //
// ./src/components/ReelClip.js